
import Logo2 from '../../assets/navbar/logo.svg';
import React, { useState, useEffect, useRef } from 'react';
import '../homepage/homepage.css';
import { useNavigate } from 'react-router';
import SubmitIcon from "../../assets/contactus/submit.svg";
import './auth.css'
import { ApiHelper } from '../../utilFunctions/utilfunction';
import { useForm } from 'react-hook-form';
export const ForgotPassword = () => {
    const [banner, setBanner] = useState();

    const [flashmessage, setFlashmessage] = useState(false)
    const [loading, setLoading] = useState(false);
    // For recaptcha 
    const [recaptcha, setRecaptcha] = useState(true);
    const [isError, setIsError] = useState(false);
    // For validation
    // For validation

    const [messagess, setMessagess] = useState('');

    const { register, handleSubmit, formState: { errors }, reset, trigger } = useForm();

    const Submit = async (event) => {
        setFlashmessage(false);
        setMessagess("");
        setLoading(true)
        const { email } = event;

        const reqToSend = { email };

        try {
            const url = "/forgot-password";
            const response = await ApiHelper(url, reqToSend, "POST");

            if (response?.code === 200 && response?.status === true) {
                setIsError(false);
                setFlashmessage(true);
                setMessagess(response.message || "Reset link sent to your email.");

            } else {
                const errorMsg = response?.message || "Rest Password link sent failed.";

                setIsError(true);
                setMessagess(errorMsg);

                setFlashmessage(true);
            }


        } catch (error) {
            setIsError(true);
            setMessagess('Something went wrong');
            setFlashmessage(true);

        } finally {
            if (window.grecaptcha) {
                window.grecaptcha.reset();
            }
            setLoading(false)
            setTimeout(() => {
                setFlashmessage(false);
                setMessagess("");
                setIsError(false);

            }, 10000);


            reset();
        }
    };


    const [contactdesc, setContactdesc] = useState();
    const navigate = useNavigate();
    useEffect(async () => {

        let url = "/banner"
        let bannerdata = await ApiHelper(url);
        setBanner(bannerdata);
    }, [])
    return (
        <section className='mainhomepage'>

            <div className='wholepopup d-flex justify-content-center align-items-center w-100'>

                <div className='container d-flex flex-column back_image_color flex-md-row align-items-center ps-lg-0 pe-lg-0 mb-5 position-relative' >



                    {
                        banner && banner.data.length ?
                            <div className='col-12 col-md-6'>
                                {
                                    banner.data.map((value, index) =>

                                        <img key={index} className='for_height mw-100 w-100' src={value ? value.image_path : ""} alt="image" />

                                    )
                                }
                            </div>

                            :
                            <div className='col-12 col-md-6'>
                            </div>
                    }

                    <div className='col-12 col-md-6'>

                        <div className='rightside_content d-flex justify-content-center align-items-center' style={{ background: '#f0f0f0' }}>
                            <div className='d-flex flex-column responsive-contianer flex-grow-1 align-items-center'>

                                <img className='logo2_bottom' src={Logo2} alt="logo" style={{ marginBottom: '15px' }} />
                                <h2
                                    className="mb-2 text-center fw-bold responsive-heading"
                                >
                                    Forgot Password
                                </h2>
                                <form className='form w-100' onSubmit={handleSubmit(Submit)}>
                                    <div className='d-flex flex-column login-form w-100'>
                                        <p className="text-center mb-4" style={{ fontFamily: 'Times New Roman', fontSize: '18px' }}>
                                            Please enter your email to get a new password link.
                                        </p>

                                        <div className="textOnInput">
                                            <input className="form-control" type="text" {...register("email", { required: "Email is required" })} />
                                            {errors.email && (<p className='text-danger small'>{errors.email.message}</p>)}
                                            <label htmlFor="email">Email*</label>
                                        </div>
                                        {loading && (
                                            <div className="spinner-border text-light align-self-center" style={{
                                                width: "1.5rem",
                                                height: "1.5rem",
                                                borderWidth: "0.2em",
                                                borderColor: "#ccc", // All borders
                                                borderTopColor: "#333", // Spinner color
                                            }} role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        )}

{flashmessage && messagess && (
                                                  <div
                                                  className={`d-flex mt-1 align-items-center pt-2 pt-sm-0 ${
                                                    isError ? "text-danger" : "text-black"
                                                  }`}
                                                  style={{marginBlock:'5px'}}
                                                >
                                                  {!isError && (
                                                    <img className="ps-sm-4 pe-2" src={SubmitIcon} alt="" />
                                                  )}
                                                  <span className="fs-5">
                                                      {messagess}
                                                  </span>
                                                </div>
                                            )}


                                        <div className='d-flex justify-content-between gap-4 mt-3' style={{paddingInline: '20px'}}>
                                            <button
                                                type="button"

                                                style={{
                                                    width: '150px',
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    fontFamily: 'Times New Roman',
                                                    background: 'transparent',
                                                    border: '2px solid #000',
                                                    borderRadius: '7px',
                                                    color: '#000',
                                                }}
                                                onClick={() => navigate(-1)} // or your cancel logic
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="auth-button"
                                                style={{
                                                    width: '150px',
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    fontFamily: 'Times New Roman',
                                                }}

                                            >
                                                Submit
                                            </button>



                                        </div>

                                    </div>
                                </form>





                            </div>

                        </div>

                    </div>

                </div>
            </div>

        </section >
    )
}